import React, { useState } from "react";
import { Activity, Info } from "lucide-react";
import { api } from "../../../lib/api";
import { isCanceled, useLatestRequest } from "../../../lib/useLatest";
import { PageHeader } from "../../../components/PageHeader";
import { MonError, MonToolbar } from "./MonToolbar";
import { KindCard } from "./KindCard";
import { InstanceGrid } from "./InstanceCard";
import { KINDS, fmtWib, monErr, refreshMs, useAutoRefresh, useMonPrefs } from "./monUtil";

let metaCache = null;

export default function MonitoringOverview() {
  const prefs = useMonPrefs(); const next = useLatestRequest();
  const [data, setData] = useState(null); const [meta, setMeta] = useState(metaCache); const [err, setErr] = useState(""); const [loading, setLoading] = useState(false);
  const load = async () => {
    setLoading(true);
    try {
      const signal = next();
      const [o, m] = await Promise.all([api.get("/platform/monitoring/overview", { params: { window: prefs.win }, signal }), meta ? Promise.resolve({ data: meta }) : api.get("/platform/monitoring/meta", { signal })]);
      setData(o.data); setMeta(m.data); metaCache = m.data; setErr(""); return true;
    } catch (e) { if (!isCanceled(e)) setErr(monErr(e)); } finally { setLoading(false); }
  };
  const { refresh, at } = useAutoRefresh(load, prefs.auto, [prefs.win], refreshMs(prefs.win));
  const online = (data?.system || []).filter((s) => s.online).length;
  return (
    <div data-testid="platform-monitoring">
      <PageHeader icon={Activity} title="Monitoring" description="Kesehatan backend Oryntix: latensi HTTP, LLM, database & storage, plus metrik sistem per instance.">
        <MonToolbar prefs={prefs} onRefresh={refresh} loading={loading} at={at} />
      </PageHeader>
      <MonError msg={err} />
      {data && <p className="mb-3 text-[11px] text-slate-400" data-testid="mon-range">{fmtWib(data.from)} — {fmtWib(data.to)}</p>}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5" data-testid="mon-kinds">
        {Object.keys(KINDS).map((k) => (data || err ? <KindCard key={k} kind={k} s={data?.latency?.[k]} /> : <div key={k} className="aivora-card h-52 animate-pulse bg-slate-50" />))}
      </div>
      <div className="mb-3 mt-8 flex items-baseline gap-3">
        <h2 className="text-base font-black text-slate-900 md:text-lg">Instance</h2>
        {data && <span className="text-xs text-slate-500" data-testid="mon-online-count">{online}/{data.system?.length || 0} online</span>}
      </div>
      <InstanceGrid items={data ? data.system || [] : err ? [] : null} />
      {meta && (
        <p className="mt-6 flex flex-wrap items-center gap-x-2 text-[11px] text-slate-400" data-testid="mon-meta">
          <Info size={12} /> Data tertunda ≤ {meta.flush_sec} dtk · snapshot sistem tiap {meta.snapshot_sec} dtk · retensi {meta.retention_days} hari · DB dicatat bila ≥ {meta.slow_db_ms} ms · WS: error = exception server saja (4401/4403 = ditolak) · persentil adalah estimasi histogram · dijawab oleh <span className="font-mono">{meta.instance}</span>
        </p>
      )}
    </div>
  );
}
